/**
 * The "Molecule.dev" wordmark rendered next to the logo mark — ONE definition
 * for every surface that shows it (site header + the auth/shared pages), so
 * the treatment can't drift per page.
 *
 * Primary-colored to match the logo SVG's #4070e0 stroke (the theme's
 * `--color-primary` in both light and dark), instead of inheriting the plain
 * foreground color that visibly mismatched the mark.
 */

import { Link } from 'react-router'

import { getClassMap } from '@molecule/app-ui'
import { Flex } from '@molecule/app-ui-react'

import { APP_NAME, LOGO_SIZE } from '../branding.js'

export function LogoText() {
  const cm = getClassMap()
  // cm.logoText sets size/tracking only (no color), so the inline color does
  // not conflict with any ClassMap-managed property.
  return (
    <span className={cm.logoText} style={{ color: 'var(--color-primary)' }}>
      {APP_NAME}
    </span>
  )
}

/**
 * The header logo mark + wordmark as a LINK — home for visitors, the
 * dashboard for logged-in users. ONE definition so every navbar behaves the
 * same (it used to be plain unclickable markup on the auth pages).
 * Logged-in detection is the JS-readable `mol_auth` presence hint (the same
 * one the auth client gates session restore on) — no useAuth, so the link
 * works on public pages mounted without an AuthProvider and routes correctly
 * before the session restore resolves.
 */
export function LogoLink() {
  const loggedIn =
    typeof document !== 'undefined' && /(?:^|;\s*)mol_auth=1(?:;|$)/.test(document.cookie)
  return (
    <Link to={loggedIn ? '/dashboard' : '/'} style={{ textDecoration: 'none' }}>
      <Flex align="center" gap="xs">
        <img src="/logo.svg" width={LOGO_SIZE} height={LOGO_SIZE} alt="" />
        <LogoText />
      </Flex>
    </Link>
  )
}
